import { LEGAL_SUPPORT_EMAIL } from "./legal-meta";

type SupportContactHintProps = {
  className?: string;
};

/** Short line pointing users to the support mailbox. */
export default function SupportContactHint({ className }: SupportContactHintProps) {
  return (
    <p className={className ?? "support-contact-hint"}>
      Need help? Email{" "}
      <a href={`mailto:${LEGAL_SUPPORT_EMAIL}`}>{LEGAL_SUPPORT_EMAIL}</a>.
    </p>
  );
}
